export default __webpack_public_path__ + "static/media/CocoGothicUltralight.96998dc0.ttf";